import { BaseService } from "./base.service";
import { ISupplierPoPrint } from "models/SupplierPoPrint/supplierPoPrintModel";

class SupplierPoPrintServiceInternal extends BaseService {
	getSupplierPoPrintList = async (): Promise<ISupplierPoPrint[]> =>
		this.callApi<ISupplierPoPrint[]>(
			`SupplierPoPrint/GetSupplierPoPrintList`,
			"GET"
		);
}

export const SupplierPoPrintService = new SupplierPoPrintServiceInternal();
